<template>
  <div class="modal fade inactivity" tabindex="-1" :id="modalId" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content text-center">
        <div class="divToCenter">
            <div
              class="d-flex justify-content-center"
              v-bind:style="stepSpanStyle"
            >
              <span class="icon icon-cross"></span>
            </div>
        </div>
        <div class="modal-body pt-2 pb-4">
          <h2>Unable to load page</h2>
          <p>Retrieving data from the server is taking longer than expected.</p>
          <p>You may try again after 5 mins by refreshing the page</p>
          <button type="button" class="btn btn--white border-green btn--no w-auto" @click="deny">Close</button>
          <ColoredButton class="btn--yes w-auto" @click="refresh" :disabled="disableRefreshButton">Refresh ({{ remainingTime }})</ColoredButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ColoredButton from './ColoredButton';
  export default {
    components: {
      ColoredButton
    },
    props: {
      modalId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        message : null,
        confirmCallback : null,
        denyCallback : null,
        remainingTime: 300,
        disableRefreshButton: true,
        countDown: null,
      }
    },
    watch : {
      showModal : function(){
        var hashModalId = "#"+this.modalId;
        if(this.showModal){
          $(hashModalId).modalbs5({
            show: true,
            backdrop: 'static',
            keyboard: false
          })
        }
        else{
          $(hashModalId).modalbs5('hide');
        }
      },
      remainingTime(val) {
        if (val <= 0) {
          this.disableRefreshButton = false;
          clearInterval(this.countDown)
        }
      },
      logo: function() {
        var fail = "<i class='icon-cross'></i>";
        return "<strong>" + fail + "</strong>";
      },
    },
    methods: {
      refresh(){
        window.location.reload();
      },
      deny(){
        this.$store.commit('SET_SHOW_MODAL_RETRY', false);
      }
    },
    computed: {
      showModal() {
        return this.$store.getters.GET_SHOW_MODAL_RETRY;
      },
      stepSpanStyle() {
        var color = "#D7010B";
        return {
          border: "1px solid " + color,
          color: "#F7F7F7",
          height: "3rem",
          width: "3rem",
          "border-radius": "50%",
          "background-color": color,
          "font-size": "1.125rem",
          "align-items": "center !important",
          "justify-content": "center !important"
        };
      }
    },
    mounted() {
      this.countDown = setInterval(() => {
        this.remainingTime--;
      }, 1000);
    }
  }
</script>

<style scoped>

.divToCenter {
    margin: 1rem auto;
}
</style>